import Heading from "components/Heading/Heading";
import React, { ReactNode } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

export interface ServiceItem {
  id: number;
  title: string;
  description: string;
  link: string;
}

interface ServicesSwiperSectionProps {
  className?: string;
  heading?: ReactNode;
  subHeading?: string;
}

const servicesData: ServiceItem[] = [
  {
    id: 1,
    title: "Payment services",
    description: "Fast, seamless international payments of suppliers and staff in 120 countries.",
    link: "/payment",
  },
  {
    id: 2,
    title: "Foreign Exchange",
    description: "Bank beating foreign exchange rates, instant transfers and availability.",
    link: "/foreign-exchange",
  },
  {
    id: 3,
    title: "Online Banking",
    description: "Your business is in your pocket, keeping your financial world at your fingertips.",
    link: "/online-banking",
  },
];

const ServiceCard: React.FC<ServiceItem> = ({ title, description, link }) => (
  <div className="flex flex-col min-h-[280px] p-8 bg-white rounded-3xl border border-gray-200 transition-all duration-300 hover:border-blue-600 group cursor-pointer">
    <h3 className="text-2xl font-normal text-indigo-700 mb-4">{title}</h3>
    <p className="text-gray-600 text-base  flex-grow">{description}</p>
    <a href={link} className="w-fit flex items-center text-slate-800 group-hover:text-indigo-700 group-hover:border-indigo-700 px-4 py-2 border border-slate-800 rounded-full font-light mt-6">
      Learn more
      <svg className="ml-2 w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" viewBox="0 0 24 24" fill="none">
        <path d="M9 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </a>
  </div>
);

const ServicesSwiperSection: React.FC<ServicesSwiperSectionProps> = ({ className = "", heading, subHeading }) => {
  return (
    <div className={`nc-ServicesSwiperSection ${className}`}>
      {(heading || subHeading) && (
        <Heading desc={subHeading} className="mb-10 md:mb-16 text-center" isCenter>
          {heading}
        </Heading>
      )}

      <div className="relative ">
        <Swiper
          spaceBetween={24}
          slidesPerView={1.2}
          centeredSlides={false}
          loop={false}
          navigation={false}
          pagination={{
            clickable: true,
            el: ".services-swiper-pagination",
          }}
          breakpoints={{
            640: {
              slidesPerView: 2.2,
            },
            1024: {
              slidesPerView: 3,
              pagination: false,
            },
          }}
          modules={[Navigation, Pagination]}
          className="!overflow-visible"
        >
          {servicesData.map((item, index) => (
            <SwiperSlide key={item.id} className="h-auto">
              <div className={index === 1 ? "hover" : ""}>
                <ServiceCard {...item} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="services-swiper-pagination mt-6 flex justify-center md:hidden" />
      </div>
    </div>
  );
};

export default ServicesSwiperSection;
